<template>
  <div class="transit-input">
    <span v-if="prefixIcon" class="input-prefix" @click.stop="onPrefixClick">
      <img :src="prefixIcon" alt="" />
    </span>
    <input :type="type" :placeholder="placeholder" :value="value" @input="onInput" class="input-field" />
    <span v-if="showClear && value" class="input-clear" @click.stop="clearInput">
      <img :src="transitClearIcon" alt="" />
    </span>
  </div>
</template>

<script>
export default {
  name: "TransitInput",
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    placeholder: {
      type: String,
      default: "",
    },
    showClear: {
      type: Boolean,
      default: true,
    },
    prefixIcon: {
      type: String,
      default: "",
    },
    clearIcon: {
      type: String,
      default: "",
    },
  },
  computed: {
    transitClearIcon() {
      return this.clearIcon || require(`../../assets/custom-token/close${this.darkModeImg}.png`);
    },
  },
  methods: {
    onInput(e) {
      this.$emit("input", e.target.value);
    },
    clearInput() {
      this.$emit("input", "");
    },
    onPrefixClick() {
      this.$emit("prefix-click");
    },
  },
};
</script>

<style lang="less" scoped>
.transit-input {
  display: flex;
  align-items: center;
  height: 50px;
  background: var(--bg-51);
  border: 1px solid var(--border-19);
  border-radius: 8px;
  gap: 0 4px;
  padding: 0 8px;
  .input-prefix {
    // margin-right: 4px;
    display: flex;
    cursor: pointer;
    img {
      width: 20px;
      height: 20px;
    }
  }
  .input-field {
    height: 100%;
    padding: 0 12px;
    border: none;
    outline: none;
    flex: 1 1;
    min-width: 0;
    font-size: 13px;
    font-weight: 500;
    border-radius: 0;
    background: none;
    &::placeholder {
      font-size: 13px;
      color: var(--input-placeholder-1);
    }
  }
  .input-clear {
    // margin-right: 12px;
    display: flex;
    cursor: pointer;
    img {
      width: 16px;
      height: 16px;
    }
  }
}
</style>
